import React from "react";

/** Small inline switch (e.g. "Same as Dropoff", "Per Pallet"). */
function LpToggle({ checked = false, onChange, label, disabled = false, className = "", ...rest }) {
  const cls = ["lp-toggle", className].filter(Boolean).join(" ");
  return (
    <label className={cls}>
      <input type="checkbox" checked={checked} onChange={onChange} disabled={disabled} {...rest} />
      <span className="lp-toggle__track" />
      {label && <span className="lp-toggle__label">{label}</span>}
    </label>
  );
}

export default React.memo(LpToggle);
